var render = function render() {
  var _vm$actionsStore$sele, _vm$actionsStore$sele2, _vm$actionsStore$sele3, _vm$actionsStore$sele4, _vm$actionsStore$sele5, _vm$actionsStore$sele6, _vm$actionsStore$sele7, _vm$actionsStore$sele8, _vm$actionsStore$sele9, _vm$actionsStore$sele0, _vm$actionsStore$sele1, _vm$actionsStore$sele10, _vm$actionsStore$sele11, _vm$actionsStore$sele12, _vm$actionsStore$sele13;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('FilterFields', {
    attrs: {
      "fields": [{
        type: 'text',
        label: 'Documento',
        field: 'documento'
      }, {
        type: 'text',
        label: 'Fornecedor',
        field: 'fornecedor'
      }, {
        type: 'text',
        label: 'Descrição',
        field: 'descricao'
      }, {
        type: 'text',
        label: 'Meio Pag.',
        field: 'meio_pagamento'
      }, {
        type: 'select',
        label: 'Status',
        field: 'status',
        options: ['Paga', 'Atrasada', 'Pendente', 'Agrupada', 'Atrasada e Pendente', 'Todos']
      }, {
        type: 'select',
        label: 'Marcada',
        field: 'conta_marcada',
        options: ['Sim', 'Não']
      }, {
        type: 'date',
        label: 'Vencimento',
        field: 'data_vencimento'
      }, {
        type: 'date',
        label: 'Pagamento',
        field: 'data_pagamento'
      }, {
        type: 'date',
        label: 'Emissão',
        field: 'created_at'
      }, {
        type: 'text',
        label: 'Banco',
        field: 'banco'
      }, {
        type: 'text',
        label: 'Plano de contas',
        field: 'plano_de_contas'
      }, {
        type: 'text',
        label: 'Centro de custo',
        field: 'centro_custo'
      }, {
        type: 'text',
        label: 'R$ Valor',
        field: 'valor'
      }]
    }
  }), _c('div', {
    staticClass: "d-flex align-items-center my-2 mb-4",
    staticStyle: {
      "position": "absolute",
      "top": "-7px",
      "left": "110px",
      "z-index": "99"
    }
  }, [_c('b-dropdown', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.right",
      value: '',
      expression: "''",
      modifiers: {
        "right": true
      }
    }],
    attrs: {
      "text": _vm.periodFilterLabel,
      "split": "",
      "split-variant": "secondary",
      "id": "menu",
      "variant": "primary"
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "active": _vm.hasPeriodFilter && _vm.filtersStore.filterOptionSelected.id === 1
    },
    on: {
      "click": function click() {
        return _vm.filtersStore.filterOptionSelected = {
          id: 1,
          label: 'Hoje'
        };
      }
    }
  }, [_vm._v("Hoje")]), _c('b-dropdown-item', {
    attrs: {
      "active": _vm.hasPeriodFilter && _vm.filtersStore.filterOptionSelected.id === 2
    },
    on: {
      "click": function click() {
        return _vm.filtersStore.filterOptionSelected = {
          id: 2,
          label: 'Ontem'
        };
      }
    }
  }, [_vm._v(" Ontem ")]), _c('b-dropdown-item', {
    attrs: {
      "active": _vm.hasPeriodFilter && _vm.filtersStore.filterOptionSelected.id === 3
    },
    on: {
      "click": function click() {
        return _vm.filtersStore.filterOptionSelected = {
          id: 3,
          label: 'Essa semana'
        };
      }
    }
  }, [_vm._v(" Essa semana ")]), _c('b-dropdown-item', {
    attrs: {
      "active": _vm.hasPeriodFilter && _vm.filtersStore.filterOptionSelected.id === 4
    },
    on: {
      "click": function click() {
        return _vm.filtersStore.filterOptionSelected = {
          id: 4,
          label: 'Semana passada'
        };
      }
    }
  }, [_vm._v(" Semana passada ")]), _c('b-dropdown-item', {
    attrs: {
      "active": _vm.hasPeriodFilter && _vm.filtersStore.filterOptionSelected.id === 5
    },
    on: {
      "click": function click() {
        return _vm.filtersStore.filterOptionSelected = {
          id: 5,
          label: 'Esse mês'
        };
      }
    }
  }, [_vm._v(" Esse mês ")])], 1)], 1)], 1), _vm.actionsStore.selectedRows.length > 0 ? _c('b-dropdown', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.right",
      value: 'Mais ações',
      expression: "'Mais ações'",
      modifiers: {
        "right": true
      }
    }],
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "50px"
    },
    attrs: {
      "id": "menu",
      "variant": "dark"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('Menu', {
          attrs: {
            "size": 18
          }
        })];
      },
      proxy: true
    }], null, false, 2976318409)
  }, [_c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.menuAcoes",
      modifiers: {
        "menuAcoes": true
      }
    }]
  }, [_vm._v("Pagamento de Contas")]), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.duplicarContaPagar",
      modifiers: {
        "duplicarContaPagar": true
      }
    }],
    attrs: {
      "disabled": _vm.actionsStore.selectedRows.length !== 1
    }
  }, [_vm._v(" Duplicar conta ")]), _c('b-dropdown-item', {
    on: {
      "click": _vm.abrirAgrupamentoContas
    }
  }, [_vm._v("Agrupar contas")]), _c('b-dropdown-item', {
    on: {
      "click": function click() {
        return _vm.getRequestAdmin(function () {
          return _vm.$bvModal.show('estornarContas');
        });
      }
    }
  }, [_vm._v("Estornar Contas")]), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.marcarContas",
      modifiers: {
        "marcarContas": true
      }
    }]
  }, [_vm._v("Marcar/Desmarcar Contas")]), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.pagarParcial",
      modifiers: {
        "pagarParcial": true
      }
    }],
    attrs: {
      "disabled": _vm.actionsStore.selectedRows.length > 1
    },
    on: {
      "click": function click() {
        return _vm.dataVencimentoParcial = _vm.actionsStore.selectedRows[0].data_vencimento;
      }
    }
  }, [_vm._v("Pagamento Parcial ")])], 1) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "duplicarContaPagar",
      "title": "Deseja duplicar a conta a pagar selecionada?",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('div', [_c('b-button', {
          ref: "duplicar_conta_pagar",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.duplicarConta
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v("Cancelar")])], 1)];
      }
    }])
  }, [_c('p', [_vm._v(_vm._s((_vm$actionsStore$sele = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele === void 0 ? void 0 : _vm$actionsStore$sele.historico))])]), _c('b-modal', {
    attrs: {
      "id": "estornarContas",
      "title": "Deseja estornar as Contas?",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var ok = _ref2.ok,
          cancel = _ref2.cancel;
        return [_c('div', [_c('b-button', {
          ref: "estornar_contas",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.estornar
          }
        }, [_vm._v(" Estornar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "marcarContas",
      "title": "Deseja marcar as Contas?",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref3) {
        var ok = _ref3.ok,
          cancel = _ref3.cancel;
        return [_c('div', [_c('b-button', {
          ref: "marcarContas",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.marcar
          }
        }, [_vm._v(" Marcar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('p', [_vm._v(" Recurso utilizado para melhorar a visualização das contas selecionadas. ")])]), _c('b-modal', {
    attrs: {
      "id": "menuAcoes",
      "title": "Pagamentos em massa",
      "centered": "",
      "size": "xl"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref4) {
        var ok = _ref4.ok,
          cancel = _ref4.cancel;
        return [_c('div', {
          staticClass: "d-flex"
        }, [_c('DatePickerInput', {
          attrs: {
            "label": "Data de pagamento",
            "mode": "single"
          },
          on: {
            "valueUpdated": function valueUpdated(date) {
              _vm.dataPagamento = date;
            }
          }
        }), _c('b-form-group', {
          staticClass: "mr-5",
          attrs: {
            "id": "bancoPagamento",
            "label-for": "bancoPagamento",
            "label": "Conta"
          }
        }, [_c('b-form-select', {
          model: {
            value: _vm.bancoPagamento,
            callback: function callback($$v) {
              _vm.bancoPagamento = $$v;
            },
            expression: "bancoPagamento"
          }
        }, _vm._l(_vm.bancos, function (b) {
          return _c('b-form-select-option', {
            key: b.id_banco + 'bancos',
            attrs: {
              "value": b
            }
          }, [_vm._v(" " + _vm._s(b.nome) + " ")]);
        }), 1)], 1), _c('b-form-group', {
          attrs: {
            "id": "meioPagamento",
            "label-for": "meioPagamento",
            "label": "Meio de pagamento"
          }
        }, [_c('b-form-select', {
          model: {
            value: _vm.meioPagamento,
            callback: function callback($$v) {
              _vm.meioPagamento = $$v;
            },
            expression: "meioPagamento"
          }
        }, _vm._l(_vm.meiosPagamentos, function (meio) {
          return _c('b-form-select-option', {
            key: meio.id + 'meio',
            attrs: {
              "value": meio
            }
          }, [_vm._v(" " + _vm._s(meio.descricao) + " ")]);
        }), 1)], 1), _c('b-form-group', {
          staticClass: "ml-5",
          attrs: {
            "label": "Total do pagamento R$",
            "label-for": "totalPagamento"
          }
        }, [_c('money', _vm._b({
          staticClass: "form-control",
          attrs: {
            "id": "totalPagamento",
            "name": "totalPagamento",
            "value": _vm.totalPagamento,
            "disabled": ""
          }
        }, 'money', _vm.configMask, false))], 1)], 1), _c('div', [_c('b-button', {
          ref: "pagar_contas",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.pagarContas
          }
        }, [_vm._v(" Pagar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('b-form', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "max-height": "450px",
      "overflow": "auto"
    }
  }, [_vm.actionsStore.selectedRows.length > 0 ? _c('b-table', {
    attrs: {
      "striped": "",
      "small": "",
      "hover": "",
      "items": _vm.pagamentoTableItems,
      "fields": _vm.actionTableFields
    },
    scopedSlots: _vm._u([{
      key: "cell(actions)",
      fn: function fn(row) {
        return [_c('button', {
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click() {
              return _vm.handleRemoveContaAPagar(row);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)];
      }
    }], null, false, 454818138)
  }) : _vm._e()], 1)])], 1), _c('b-modal', {
    attrs: {
      "id": "agruparContas",
      "title": "Agrupar contas a pagar",
      "centered": "",
      "size": "xl"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref5) {
        var ok = _ref5.ok,
          cancel = _ref5.cancel;
        return [_c('div', {
          staticClass: "d-flex"
        }, [_c('DatePickerInput', {
          attrs: {
            "label": "Vencimento da nova conta",
            "mode": "single"
          },
          on: {
            "valueUpdated": function valueUpdated(date) {
              _vm.dataVencimentoAgrupamento = date;
            }
          }
        }), _c('b-form-group', {
          staticClass: "mr-5",
          attrs: {
            "id": "bancoAgrupamento",
            "label-for": "bancoAgrupamento",
            "label": "Conta"
          }
        }, [_c('b-form-select', {
          model: {
            value: _vm.bancoAgrupamento,
            callback: function callback($$v) {
              _vm.bancoAgrupamento = $$v;
            },
            expression: "bancoAgrupamento"
          }
        }, _vm._l(_vm.bancos, function (b) {
          return _c('b-form-select-option', {
            key: b.id_banco + 'bancosAgrupamento',
            attrs: {
              "value": b
            }
          }, [_vm._v(" " + _vm._s(b.nome) + " ")]);
        }), 1)], 1), _c('b-form-group', {
          attrs: {
            "id": "meioPagamentoAgrupamento",
            "label-for": "meioPagamentoAgrupamento",
            "label": "Meio de pagamento"
          }
        }, [_c('b-form-select', {
          model: {
            value: _vm.meioPagamentoAgrupamento,
            callback: function callback($$v) {
              _vm.meioPagamentoAgrupamento = $$v;
            },
            expression: "meioPagamentoAgrupamento"
          }
        }, _vm._l(_vm.meiosPagamentos, function (meio) {
          return _c('b-form-select-option', {
            key: meio.id + 'meioAgrupamento',
            attrs: {
              "value": meio
            }
          }, [_vm._v(" " + _vm._s(meio.descricao) + " ")]);
        }), 1)], 1), _c('b-form-group', {
          staticClass: "ml-5",
          attrs: {
            "label": "Total agrupado R$",
            "label-for": "totalAgrupamento"
          }
        }, [_c('money', _vm._b({
          staticClass: "form-control",
          attrs: {
            "id": "totalAgrupamento",
            "name": "totalAgrupamento",
            "value": _vm.totalAgrupamento,
            "disabled": ""
          }
        }, 'money', _vm.configMask, false))], 1), _c('b-form-group', {
          staticClass: "ml-3",
          attrs: {
            "label": "Desconto R$",
            "label-for": "descontoAgrupamento"
          }
        }, [_c('money', _vm._b({
          staticClass: "form-control",
          attrs: {
            "id": "descontoAgrupamento",
            "name": "descontoAgrupamento",
            "masked": false
          },
          model: {
            value: _vm.descontoAgrupamento,
            callback: function callback($$v) {
              _vm.descontoAgrupamento = _vm._n($$v);
            },
            expression: "descontoAgrupamento"
          }
        }, 'money', _vm.configMask, false))], 1)], 1), _c('div', [_c('b-button', {
          ref: "agrupar_contas",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.agruparContas
          }
        }, [_vm._v(" Agrupar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.resetAgrupamentoData();
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('b-form', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "max-height": "450px",
      "overflow": "auto"
    }
  }, [_vm.actionsStore.selectedRows.length > 0 ? _c('b-table', {
    attrs: {
      "striped": "",
      "small": "",
      "hover": "",
      "items": _vm.agrupamentoTableItems,
      "fields": _vm.actionTableFields
    },
    scopedSlots: _vm._u([{
      key: "cell(actions)",
      fn: function fn(row) {
        return [_c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Excluir',
            expression: "'Excluir'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click() {
              return _vm.handleRemoveContaAPagar(row);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)];
      }
    }], null, false, 991746363)
  }) : _vm._e()], 1)])], 1), _c('b-modal', {
    attrs: {
      "id": "modalEscolherModelo",
      "title": "Escolha o modelo de exportação",
      "centered": "",
      "size": "md",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "mb-3 text-center text-muted",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('strong', [_vm._v("Atenção:")]), _vm._v(" Serão exportados somente os dados atualmente "), _c('br'), _c('span', {
    staticClass: "text-success font-weight-bold"
  }, [_vm._v("listados em tela")]), _vm._v(", conforme filtros aplicados. ")]), _c('div', {
    staticClass: "d-flex flex-column align-items-center"
  }, [_c('b-button', {
    staticClass: "mb-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.exportarXLS('nuts');
      }
    }
  }, [_vm._v(" Modelo Default ")]), _c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.exportarXLS('questor');
      }
    }
  }, [_vm._v(" Modelo Questor ")])], 1)]), _c('b-tooltip', {
    attrs: {
      "target": "menu",
      "placement": "right",
      "show": _vm.showTooltipMenu
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.showTooltipMenu = $event;
      }
    }
  }, [_vm._v(" Pagamentos de contas ")]), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Exportar para Excel',
      expression: "'Exportar para Excel'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    staticClass: "ml-2 border border-muted",
    staticStyle: {
      "position": "absolute",
      "right": "13px",
      "top": "2px"
    },
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.show('modalEscolherModelo');
      }
    }
  }, [_c('FileExcel', {
    attrs: {
      "size": 18
    }
  })], 1), _c('TableApp', {
    ref: "contaPagar",
    attrs: {
      "titulo": "Contas a Pagar",
      "subTitulo": "Lista de Contas a Pagar",
      "acaoBtn": "/#/contasPagar/novo",
      "textoBtn": "Nova",
      "api-url": "/contapagar",
      "fields": _vm.fields,
      "classFilterColumn": "historico",
      "perPage": 10,
      "multiselect": true
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'documento' ? _c('span', {
          attrs: {
            "slot": "documento"
          },
          slot: "documento"
        }, [_c('span', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', [_c('a', {
          staticClass: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
        }, [_vm._v(_vm._s(props.rowData.documento))]), _c('div', {
          staticClass: "d-flex align-items-center flex-wrap"
        }, [_c('span', {
          staticClass: "text-muted font-weight-bold"
        }, [_vm._v(" " + _vm._s(props.rowData.historico) + " ")]), props.rowData.centro_custo ? _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: 'Centro de custo',
            expression: "'Centro de custo'",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "badge badge-light-primary d-inline-flex align-items-center ml-2"
        }, [_c('TagOutline', {
          staticClass: "mr-1",
          attrs: {
            "size": 13
          }
        }), _vm._v(" " + _vm._s(props.rowData.centro_custo) + " ")], 1) : _vm._e()]), props.rowData.plano_contas ? _c('span', {
          staticClass: "text-muted d-block",
          staticStyle: {
            "font-size": "0.8rem"
          }
        }, [_vm._v(" " + _vm._s(props.rowData.plano_contas.descricao) + " ")]) : _vm._e()])])])]) : _vm._e(), props.field == 'fornecedor' ? [_c('div', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', [_c('span', {
          staticClass: "text-muted font-weight-bold d-block"
        }, [_vm._v(" " + _vm._s(props.rowData.fornecedor) + " ")]), props.rowData.cnpj_cpf ? _c('span', {
          staticClass: "text-muted d-block",
          staticStyle: {
            "font-size": "0.85rem",
            "cursor": "pointer"
          },
          attrs: {
            "title": "Clique para copiar"
          },
          on: {
            "click": function click($event) {
              return _vm.copyToClipboard(props.rowData.cnpj_cpf);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.formatCpfCnpj(props.rowData.cnpj_cpf)) + " ")]) : _vm._e()])])] : _vm._e(), props.field == 'created_at' ? _c('span', {
          attrs: {
            "slot": "created_at"
          },
          slot: "created_at"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.formatDate(props.rowData.created_at)) + " ")])]) : _vm._e(), props.field == 'data_vencimento' ? _c('span', {
          attrs: {
            "slot": "data_vencimento"
          },
          slot: "data_vencimento"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.formatDate(props.rowData.data_vencimento)) + " ")])]) : _vm._e(), props.field == 'data_pagamento' ? _c('span', {
          attrs: {
            "slot": "data_pagamento"
          },
          slot: "data_pagamento"
        }, [props.rowData.data_pagamento != null ? _c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.formatDate(props.rowData.data_pagamento)) + " ")]) : _vm._e()]) : _vm._e(), props.field == 'valor' ? _c('span', {
          attrs: {
            "slot": "valor"
          },
          slot: "valor"
        }, [props.rowData.valor_total > 0 ? _c('div', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Conta está calculando Juros: Valor Orignal + Juros + Multa - Desconto',
            expression: "\n            'Conta está calculando Juros: Valor Orignal + Juros + Multa - Desconto'\n          "
          }]
        }, [_c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg"
        }, [_vm._v("R$ " + _vm._s(_vm.numberToReal(props.rowData.valor_total, 2)) + " ")]), _c('span', {
          staticClass: "text-muted font-weight-bold d-block",
          staticStyle: {
            "font-size": "12px"
          }
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.valor, 2)) + " + " + _vm._s(_vm.numberToReal(props.rowData.juros, 2)) + " + " + _vm._s(_vm.numberToReal(props.rowData.multa, 2)) + " - " + _vm._s(_vm.numberToReal(props.rowData.desconto, 2)) + " ")])]) : _c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg"
        }, [_vm._v("R$ " + _vm._s(_vm.numberToReal(props.rowData.valor, 2)) + " ")])]) : _vm._e(), props.field == 'meio_pagamento' ? _c('span', {
          attrs: {
            "slot": "meio_pagamento"
          },
          slot: "meio_pagamento"
        }, [_c('span', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('span', {
          staticClass: "text-muted font-weight-bold d-block"
        }, [_vm._v(_vm._s(props.rowData.meio_pagamento))]), props.rowData.id_conciliacao_bancaria || props.rowData.foi_conciliado_ofx ? _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Conciliado via OFX',
            expression: "'Conciliado via OFX'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "ml-2",
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('CheckCircle', {
          staticClass: "text-success",
          attrs: {
            "size": 14
          }
        })], 1) : _vm._e()])])]) : _vm._e(), props.field == 'status' ? _c('span', {
          attrs: {
            "slot": "status"
          },
          slot: "status"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.onRowStatus(props.rowData))
          }
        }), props.rowData.agrupada ? _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Documento gerado no agrupamento: ' + _vm.getDocumentoAgrupamento(props.rowData),
            expression: "\n              'Documento gerado no agrupamento: ' +\n              getDocumentoAgrupamento(props.rowData)\n            ",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "agrupamento-info ml-2"
        }, [_vm._v(" ! ")]) : _vm._e()])]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "130px"
          }
        }, [_c('div', {
          staticClass: "dropdown dropdown-inline"
        }, [!props.rowData.data_pagamento && !props.rowData.agrupada ? _c('router-link', {
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          attrs: {
            "to": {
              name: 'contasPagarEditar',
              params: {
                id: props.rowData.id
              }
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 16,
            "title": "Editar"
          }
        })], 1) : _vm._e(), props.rowData.id_empresa && !props.rowData.data_pagamento && !props.rowData.agrupada ? _c('button', {
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.excluir(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1) : _vm._e()], 1)])])]) : _vm._e()];
      }
    }])
  }), _vm.actionsStore.selectedRows.length > 0 ? _c('b-modal', {
    attrs: {
      "id": "pagarParcial",
      "title": "Pagamento parcial de Conta?",
      "centered": "",
      "size": "lg"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref6) {
        var ok = _ref6.ok,
          cancel = _ref6.cancel;
        return [_c('div', [_c('b-button', {
          ref: "pagar_parcial",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.pagarParcial
          }
        }, [_vm._v(" Pagar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.resetParcialData();
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }], null, false, 2653194039)
  }, [_c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', [_c('b-form-checkbox', {
    attrs: {
      "name": "nfe-saida",
      "switch": "",
      "size": "lg"
    },
    model: {
      value: _vm.descontoParcial,
      callback: function callback($$v) {
        _vm.descontoParcial = $$v;
      },
      expression: "descontoParcial"
    }
  }, [_vm._v(" Pagar Parcial / Desconto ")])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "documento",
      "label-for": "documento",
      "label": "Documento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": (_vm$actionsStore$sele2 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele2 === void 0 ? void 0 : _vm$actionsStore$sele2.documento,
      "disabled": ""
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "fornecedor",
      "label-for": "fornecedor",
      "label": "Fornecedor"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": (_vm$actionsStore$sele3 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele3 === void 0 ? void 0 : _vm$actionsStore$sele3.fornecedor,
      "disabled": ""
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_vencimento",
      "label-for": "data_vencimento",
      "label": "Vencimento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.formatDate((_vm$actionsStore$sele4 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele4 === void 0 ? void 0 : _vm$actionsStore$sele4.data_vencimento),
      "disabled": ""
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_pagamento",
      "label-for": "data_pagamento",
      "label": "Pagamento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.formatDate((_vm$actionsStore$sele5 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele5 === void 0 ? void 0 : _vm$actionsStore$sele5.data_pagamento),
      "disabled": ""
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "valor",
      "label-for": "valor",
      "label": "Valor R$"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.numberToReal(parseFloat((_vm$actionsStore$sele6 = (_vm$actionsStore$sele7 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele7 === void 0 ? void 0 : _vm$actionsStore$sele7.valor) !== null && _vm$actionsStore$sele6 !== void 0 ? _vm$actionsStore$sele6 : 0), 2),
      "disabled": ""
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "juros",
      "label-for": "juros",
      "label": "Juros R$"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.numberToReal(parseFloat((_vm$actionsStore$sele8 = (_vm$actionsStore$sele9 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele9 === void 0 ? void 0 : _vm$actionsStore$sele9.juros) !== null && _vm$actionsStore$sele8 !== void 0 ? _vm$actionsStore$sele8 : 0), 2),
      "disabled": ""
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "multa",
      "label-for": "multa",
      "label": "Multa R$"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.numberToReal(parseFloat((_vm$actionsStore$sele0 = (_vm$actionsStore$sele1 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele1 === void 0 ? void 0 : _vm$actionsStore$sele1.multa) !== null && _vm$actionsStore$sele0 !== void 0 ? _vm$actionsStore$sele0 : 0), 2),
      "disabled": ""
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "desconto",
      "label-for": "desconto",
      "label": "Desconto R$"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.numberToReal(parseFloat((_vm$actionsStore$sele10 = (_vm$actionsStore$sele11 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele11 === void 0 ? void 0 : _vm$actionsStore$sele11.desconto) !== null && _vm$actionsStore$sele10 !== void 0 ? _vm$actionsStore$sele10 : 0), 2),
      "disabled": ""
    }
  })], 1)], 1)], 1), _c('b-row', {
    staticClass: "border-bottom"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "valor_total",
      "label-for": "valor_total",
      "label": "Vlr. Receber R$"
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.numberToReal(parseFloat((_vm$actionsStore$sele12 = (_vm$actionsStore$sele13 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele13 === void 0 ? void 0 : _vm$actionsStore$sele13.valor_total) !== null && _vm$actionsStore$sele12 !== void 0 ? _vm$actionsStore$sele12 : 0), 2),
      "disabled": ""
    }
  })], 1)], 1)], 1), _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "dataVencimento",
      "label-for": "dataVencimento",
      "label": "Data Vencimento"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "locale": "pt-br",
      "date-format-options": {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }
    },
    model: {
      value: _vm.dataVencimentoParcial,
      callback: function callback($$v) {
        _vm.dataVencimentoParcial = $$v;
      },
      expression: "dataVencimentoParcial"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "dataPagamento",
      "label-for": "dataPagamento",
      "label": "Data Pagamento"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "locale": "pt-br",
      "date-format-options": {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }
    },
    model: {
      value: _vm.dataPagamentoParcial,
      callback: function callback($$v) {
        _vm.dataPagamentoParcial = $$v;
      },
      expression: "dataPagamentoParcial"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    staticClass: "mr-5",
    attrs: {
      "id": "bancoRecebimento",
      "label-for": "bancoRecebimento",
      "label": "Conta"
    }
  }, [_c('b-form-select', {
    model: {
      value: _vm.contaParcial,
      callback: function callback($$v) {
        _vm.contaParcial = $$v;
      },
      expression: "contaParcial"
    }
  }, _vm._l(_vm.bancos, function (b) {
    return _c('b-form-select-option', {
      key: b.id_banco + 'bancos',
      attrs: {
        "value": b
      }
    }, [_vm._v(" " + _vm._s(b.nome) + " ")]);
  }), 1)], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "meioPagamento",
      "label-for": "meioPagamento",
      "label": "Meio de pagamento"
    }
  }, [_c('b-form-select', {
    model: {
      value: _vm.meioPagamentoParcial,
      callback: function callback($$v) {
        _vm.meioPagamentoParcial = $$v;
      },
      expression: "meioPagamentoParcial"
    }
  }, _vm._l(_vm.meiosPagamentos, function (meio) {
    return _c('b-form-select-option', {
      key: meio.id + 'meio',
      attrs: {
        "value": meio
      }
    }, [_vm._v(" " + _vm._s(meio.descricao) + " ")]);
  }), 1)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Valor Pago R$",
      "label-for": "valor_parcial"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "valor_parcial",
      "name": "valor_parcial"
    },
    model: {
      value: _vm.valorParcial,
      callback: function callback($$v) {
        _vm.valorParcial = $$v;
      },
      expression: "valorParcial"
    }
  }, 'money', _vm.configMask, false))], 1)], 1)], 1), _vm.valorParcial > 0 ? _c('b-row', [!_vm.descontoParcial ? _c('b-col', [_vm._v(" Você irá gerar uma nova conta à receber no valor de "), _c('span', {
    staticClass: "font-weight-bold text-primary"
  }, [_vm._v("R$" + _vm._s(_vm.numberToReal(_vm.parcialValueToDisplay - _vm.valorParcial)))]), _vm._v(" ? ")]) : _c('b-col', [_vm._v(" Você deseja gerar desconto no valor de "), _c('span', {
    staticClass: "font-weight-bold text-primary"
  }, [_vm._v("R$" + _vm._s(_vm.numberToReal(_vm.parcialValueToDisplay - _vm.valorParcial, 2)))]), _vm._v(" ? ")])], 1) : _vm._e()], 1) : _vm._e(), _c('Chart', {
    attrs: {
      "endpoint": "/contapagar/total",
      "modulo": "contapagar"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };